import { html, TemplateResult } from "lit/html.js";

const CloseButtonTemplate = (handleCloseModal: () => void): TemplateResult =>
  html`<button @click=${handleCloseModal} class="modal-close icon-cancel" title="Close"><span class="sr-only">Close</span></button>`;

export default CloseButtonTemplate;